<!--
 * @Description: 搜索框
 * pc端：搜索时总是显示x,点击x取消搜索
 * 移动端：搜索时，增加取消按钮，点击取消，回到无搜索界面
 * @Author: cooky
 * @Date: 2021-03-01 11:18:48
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-31 14:52:39
-->
<template>
  <div class="searchbox" :class="{'active': isActive}">
    <div>
      <i class="icon icon-search" @click="focus"></i>
      <input
        type="text"
        ref="input"
        :placeholder="placeholder"
        v-model="searchText"
        @focus.stop="handleFocus"
        @blur="handleBlur()"
        @input="handleChange"
        @touchmove.prevent>
      <i class="icon icon-clear" v-if="($store.state.isPc && isActive) || searchText" @click.stop="handleClear"></i>
    </div>
    <!--  v-if="isActive && !$store.state.isPc" -->
    <a v-if="isActive && !$store.state.isPc" @click="handleCancel">{{ $t("cancel") }}</a>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Searchbox',
  data () {
    return {
      placeholder: this.$t('search_gift'),
      searchText: '',
      isFocus: false
    }
  },
  computed: {
    isActive () {
      const isActive = this.searchText || this.isFocus
      return isActive
    },
    ...mapState([
      'isPc',
      'lang'
    ])
  },
  watch: {
    lang () {
      this.placeholder = this.$t('search_gift')
    }
  },
  methods: {
    handleClear () { // pc端清除->取消搜索 移动端清除->清除文本
      // this.searchText = ''
      // // this.$refs.input.focus()
      // this.handleChange()
      if (this.$store.state.isPc) {
        this.handleCancel()
        return
      }
      this.searchText = ''
      this.$refs.input.focus()
      this.handleChange()
    },
    handleChange () {
      this.$emit('change', this.searchText, !!this.searchText || this.isFocus)
    },
    // 外部调用
    focus () {
      this.$refs.input.focus()
      this.isFocus = true
    },
    handleFocus () {
      this.isFocus = true
      this.handleChange()
    },
    handleBlur () {
      console.log('blur')
      // if (this.$store.state.isPc) {
      //   this.isFocus = false
      //   this.handleChange()
      // }
    },
    handleCancel () {
      this.searchText = ''
      this.isFocus = false
      this.handleChange()
    }
  }
}
</script>
<style lang="less" scoped>
    .searchbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
            background: #e4e4e4;
            border-radius: 44px;
            padding: 0 21px;
            transition: width 0.3s ease;
            display: flex;
            align-items: center;
            width: 136px;
            height: 44px;
        }
        input {
            height: 44px;
            width: calc(100% - 22px);
            margin-left: 5px;
            outline: none;
            border: 0;
            background: transparent;
            font-size: 16px;
            color: #333;
        }
        &.active {
            >div {

                width: 377px;
            }
        }
    }
    ::-webkit-input-placeholder {
        color: #9b9b9b;
    }
    @media screen and (max-width: 750px) {
       .searchbox {
           > div {
                width: 26rem /* 195/7.5 */;
                height: 7.4667rem /* 56/7.5 */;
                padding: 2.4rem /* 18/7.5 */;
                transition: none;
           }
           input {
               font-size: 2.9333rem /* 22/7.5 */;
               height: 7.4667rem /* 56/7.5 */;
               margin-left: 1.3333rem /* 10/7.5 */;
           }
           &.active {
               width: 92rem /* 690/7.5 */;
                margin: 0 auto;
               >div {
                   width: 84.6667rem /* 635/7.5 */;
               }
            }
            a {
                font-size: 2.4rem /* 18/7.5 */;
            }
            ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                font-size: 2.9333rem /* 22/7.5 */;
            }
            :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                font-size: 2.9333rem /* 22/7.5 */;
            }
            ::-moz-placeholder { /* Mozilla Firefox 19+ */
                font-size: 2.9333rem /* 22/7.5 */;
            }
            :-ms-input-placeholder { /* Internet Explorer 10-11 */
              font-size: 2.9333rem /* 22/7.5 */;
            }
       }
    }
</style>
